import Api from "../ApiUtility/Api";

class FilesUploadDS {
  constructor() {
    this.api = new Api();
  }
  AP_Dataset_List_GET(requestData) {
    return this.api
      .postAPI(requestData, "/dev/WS_Dataset_List_GET")
      .then((data) => {
        console.log("Dataset List Response :", data);
        return data;
      })
      .catch((error) => {
        console.error("Error during Dataset List GET API call:", error);
        throw error;
      });
  }
  AP_Files_Upload_INSERT(requestData) {
    return this.api
      .postAPI(requestData, "/dev/WS_Files_Upload_For_Dataset")
      .then((data) => {
        console.log("Files Upload Response :", data);
        return data;
      })
      .catch((error) => {
        console.error("Error during Files Upload API call:", error);
        throw error;
      });
  }

}

export default FilesUploadDS;
